<script>
  import dayjs from "dayjs";
  import { formatNumber } from "@/utils";
  import { collections, Subscriber } from "@/meteor";
  export let id, url, statusOptionsObj;

  const subscribe = Subscriber("orders", { customerId: id });
  $subscribe;

  const { orders } = collections;
</script>

{#if Object.entries($orders).length}
  <h3 class="text-xl mt-8">Ordrer</h3>
  {#each Object.values($orders).filter(order => order.customerId === id) as order}
    <a href={url('/orders/:id', { id: order._id })} class="flex flex-wrap hover:bg-gray-100 hover:shadow">
      <div class="w-4/12">
        {dayjs(order.updatedAt.$date).format('DD-MM-YYYY HH:mm')}
      </div>
      <div class="w-4/12">{formatNumber(order.totalPrice, 2)} kr</div>
      <div class="w-4/12">{statusOptionsObj[order.status || 'pending']}</div>

      <!-- <div>{JSON.stringify(order)}</div> -->
    </a>
  {/each}
{/if}
